import { Component, OnInit, ViewChild } from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap';
import { AddressService } from '../../../service/api/builk/address.service';
import { MybuilkService } from '../../../service/api/builk/mybuilk.service';
import { MyBuilkFeedListModel, MyBuilkFeedListQueryModel } from '../../../model/builk/mybuilk/mybuilk-feed.model';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PolicyService } from '../../../service/policy.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from '../../../../environments/environment';
import { AuthorizedApps } from '../../../enum/shared/authorized-apps.enum';

@Component({
  selector: 'app-mybuilk',
  templateUrl: './mybuilk.component.html',
  styleUrls: ['./mybuilk.component.scss']
})
export class MybuilkComponent implements OnInit {

  // string
  country: string = 'TH';
  searchText: string = '';

  // boolean
  isLoading: boolean = false;
  isError: boolean = false;
  isCultureAccess: boolean = false;

  // model
  queryModel: MyBuilkFeedListQueryModel = new MyBuilkFeedListQueryModel();
  myBuilkFeedListModel: MyBuilkFeedListModel = new MyBuilkFeedListModel();

  // array
  itemList: Array<any> = new Array<any>();
  combines: any = [];
  countryOptions: Array<{ value: any, label: string }> = [];

  // number
  messageSize: number = 200;
  insertUserFeed: number;

  private inputChange: Subject<string> = new Subject<string>();
  private subscription: Subscription;

  constructor(
    private readonly addressService: AddressService,
    private mybuilkService: MybuilkService,
    private readonly policyService: PolicyService,
    private readonly localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    // this.initData();
    this.getCountry('th');
    this.subscription = this.inputChange  // search after typing delay 1 sec
    .pipe(debounceTime(1000))
    .subscribe((keyword: string) => {
      this.searchFeed(keyword);
    });
    // this.combineFeed(this.country.toUpperCase());
    this.getCulture();
  }

  initData() {
    this.queryModel.pageNumber = 1;
    this.queryModel.pageSize = 10;
    this.queryModel.textSearch = '';
    this.queryModel.countryCode = this.country;
  }

  combineFeed(countryCode: string): void {
    this.isLoading = true;
    this.country = countryCode;
    this.mybuilkService.getMyBuilkFeeds(this.queryModel)
      .subscribe(userFeed => {
        this.myBuilkFeedListModel = userFeed;
        this.combines = userFeed.itemList.map(val => this.initialPost(val));
        this.isLoading = false;
      });
  }

  searchFeed(keyword: string) {
    this.queryModel.textSearch = keyword;
    this.queryModel.pageNumber = 1;
    this.combineFeed(this.country.toUpperCase());
  }

  onKeywordChange() {
    if(this.queryModel.textSearch != this.searchText) {
      // keyword has change
      this.inputChange.next(this.searchText);
    }
  }

  clearDate() {
    this.queryModel.date = undefined;
    this.combineFeed(this.country.toUpperCase());
  }

  onFilterChange() {
    this.queryModel.countryCode = this.country;
    this.combineFeed(this.country.toUpperCase());
  }

  onPageChange(event: PageChangedEvent) {
    this.queryModel.pageNumber = event.page;
    window.scrollTo(0, 0);
    this.combineFeed(this.country.toUpperCase());
  }

  getCountry(language: string): any {
    this.addressService.getCompanyCountries().subscribe(ct => {
      this.addressService.getCountry(language).subscribe(res => {
        const countries = res.map(x => {
          return {
            label: x.text,
            value: x.id
          };
        });

        // Filter countries based on ct array
        const filteredCountries = countries.filter(country => ct.includes(country.value));

        // Sort the filtered countries array to prioritize "th" and "ph" first
        filteredCountries.sort((a, b) => {
          if (a.value === 'TH') {
            return -1; // "th" comes first
          } else if (b.value === 'TH') {
            return 1; // "th" comes first
          } else if (a.value === 'PH') {
            return -1; // "ph" comes second
          } else if (b.value === 'PH') {
            return 1; // "ph" comes second
          } else {
            return 0; // maintain the order for other countries
          }
        });

        filteredCountries.unshift(
          {
            value: '',
            label: 'All',
          }
        );

        this.countryOptions = filteredCountries.map(val => val);
      });
    });
  }

  initialPost(post: any): any {
    if (post !== undefined) {
      if (post.message) {
        post.messageShow = this.setReadMoreMessage(post);
        post.expand = false;
      }
      if (post.comments) {
        post.comments.forEach(element => {
          element.messageShow = this.setReadMoreMessage(element);
          element.expand = false;
        });
      }
    }
    return post;
  }

  setReadMoreMessage(obj: any): string {
    let messageResult: string = obj.message;
    if (obj.message.length > this.messageSize) {
      obj.readMore = true;
      messageResult = `${obj.message.substring(0, this.messageSize)}...`;
    }
    return messageResult;
  }

  readMore(obj: any): any {
    obj.messageShow = (obj.expand) ? this.setReadMoreMessage(obj) : obj.message;
    obj.expand = !obj.expand;

    return obj;
  }

  deletePost(post: any): void {
    const data: any = {
      id: post.id,
      userSurrKey: post.userId
    };
    this.mybuilkService.deletePost(data)
      .subscribe(
        response => {
          for (let i = 0; i < this.combines.length; i++) {
            if (this.combines[i].id === post.id) {
              this.combines.splice(i, 1);
            }
          }
        },
        err => { }
      );
  }

  dateParse(text: string) {
    return this.mybuilkService.dateParse(text);
  }

  addAnchorsToText(text) {
    return this.mybuilkService.addAnchorsToText(text);
  }

  getCulture() {
    this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,"userEmail", this.localStorageService.get<string>("userEmail")).subscribe(response => {
      if (response.length > 0) {
        const authorizedApp = response[0].authorizedApps.find(f => f.appName === AuthorizedApps.Builk);
        if (authorizedApp !== undefined) {
          let country = authorizedApp.country;
          this.queryModel.culture = country.join(",");
          if (country.length > 0) {
            if (country.some(val => val.toLocaleLowerCase() == 'th')) {
              this.isCultureAccess = true;
            } else {
              this.country = country.pop();
            }
          }
          this.initData();
          this.combineFeed(this.country.toUpperCase());
        }
      }
    });
  }
}
